/**
 * Fork overlay (new file, no OSS equivalent) — EVA-M6.
 * Account-scoped client for the Eva custom HTTP tools API.
 */
/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class EvaCustomToolsAPI extends ApiClient {
  constructor() {
    super('eva/custom_tools', { accountScoped: true });
  }

  // Run the tool once with sample params (M7 7.5, B2) → { ok, result } | { ok: false, error }.
  test(id, parameters = {}) {
    return axios.post(`${this.url}/${id}/test`, { parameters });
  }
}

export default new EvaCustomToolsAPI();
